import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./Carousel.scss";
import { Banner } from "./Banner";

const Carousels = ({ banners }) => {
  return (
    <div className="myCarouselMain">
      <Carousel variant="dark">
        {banners?.map((item, index) => {
          return (
            banners.length > 0 && (
              <Carousel.Item>
                {item.bannerUrl !== "" && item.bannerUrl !== null ? (
                  <div onClick={() => window.open(item.bannerUrl, "_blank")}>
                    {item.bannerImage !== "" ? (
                      <Banner img={item.bannerImage} id={item.bannerId} />
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div>
                    {item.bannerImage !== "" ? (
                      <Banner img={item.bannerImage} id={item.bannerId} />
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </Carousel.Item>
            )
          );
        })}
      </Carousel>
    </div>
  );
};

export default Carousels;
